import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { liquidityNeedsOpts } from './LiquidityNeeds.meta';
import { MarginProps } from '../../../../theme/styledProps';
import { Wrapper } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';

const fieldName = 'liquidityNeeds';

export const LiquidityNeeds: React.FC<MarginProps> = props => {
  const formBag = useFormContext();

  return (
    <Wrapper {...props}>
      <Controller
        control={formBag.control}
        name={fieldName}
        render={({ field }) => (
          <Select
            value={liquidityNeedsOpts.find(({ value }) => value === field.value)}
            label="How would you classify your liquidity needs?"
            onChange={opt => {
              if (opt) {
                formBag.setValue(fieldName, opt.value);
              }
            }}
            options={liquidityNeedsOpts}
          />
        )}
      />
    </Wrapper>
  );
};
